import React from "react";
import { Link } from "react-router-dom";

const DiscountOne = () => {
  return (
    <section className="promo-section pt-80">
      <div className="container container-lg">
        <div className="row gy-4">
          {/* Left Banner */}
          <div className="col-12 col-xl-6">
            <Link to="/holesaw-drillbit" className="promo-banner-card">
              <img
                src="assets/images/thumbs/hopesaw.png"
                alt="Hole Saw and Drill Bit"
                className="promo-banner-image"
              />
            </Link>
          </div>

          {/* Right Banner */}
          <div className="col-12 col-xl-6">
            <Link to="/hdpesheet-nylonsheet" className="promo-banner-card">
              <img
                src="assets/images/thumbs/hdpesheets.png"
                alt="HDPE Sheets and Nylon Rods"
                className="promo-banner-image"
              />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DiscountOne;
